class ScShowMoreItems extends HTMLElement {
  constructor() {
    super()
    this.resultType = this.dataset.type

    this.setListener()
  }

  setListener() {
    this.addEventListener('click', (e) => {
      e.preventDefault()
      if (!e.target.classList.contains('disable-fetch')) {
        e.target.classList.add('disable-fetch')

        let shopifyID = this.dataset.id,
          url = `${this.dataset.page}&section_id=${shopifyID}&type=${this.resultType}`
        fetch(url)
          .then((response) => response.text())
          .then((data) => {
            this.appendElements(data, e)
          })
          .catch(() => {
            document.querySelector('.js-show-more-items').classList.remove('disable-fetch')
          })
      }
    })
  }

  appendElements(data, e) {
    const parser = new DOMParser(),
      parsedHTML = parser.parseFromString(data, 'text/html')
    let incomingItems = parsedHTML.querySelector('.js-paginated-grid'),
      nextShowMore = parsedHTML.querySelector('.js-show-more-items'),
      itemGrid = this.closest('.js-grid-wrapper').querySelector('.js-paginated-grid')
    itemGrid.innerHTML += incomingItems.innerHTML
    
    let itemCount = itemGrid.querySelectorAll('.js-pagination-card-counter').length
    this.closest('.js-grid-wrapper')?.querySelector('.viewed-counter')?.setAttribute('item-count', `${itemCount}`);
     const counter = this.closest('.js-grid-wrapper')?.querySelector('.viewed-counter');
     counter.innerHTML = `${itemCount}`;

    if (!nextShowMore) {
      this.style.display = 'none'
      this.closest('#ScPagination').classList.add('hidden')
    } else {
      this.dataset.page = nextShowMore.dataset.page
    }
    e.target.classList.remove('disable-fetch')
    e.target.querySelector('.collection-loader').classList.add('hidden')
  }
}

customElements.define('sc-show-more-items', ScShowMoreItems)

class ScDefaultPagination extends HTMLElement {
  constructor() {
    super()

    this.addEventListener('click', (e) => {
      e.preventDefault()
      if (e.target.href) {
        let shopifyID = this.dataset.id,
          url = `${e.target.href}&section_id=${shopifyID}`
        fetch(url)
          .then((response) => response.text())
          .then((data) => {
            this.replaceElements(data)
            document.querySelector('facet-filters-form')?.setAttribute('page-changed', `${e.target.innerText}`)
          })
      }
    })
  }

  replaceElements(data) {
    const section = this.closest('section')
    const parser = new DOMParser(),
      parsedHTML = parser.parseFromString(data, 'text/html')
    let incomingItems = parsedHTML.querySelector('.js-paginated-grid'),
      itemGrid = document.querySelector('.js-paginated-grid'),
      incomingPagination = parsedHTML.querySelector('.js-default-pagination')

    itemGrid.innerHTML = incomingItems.innerHTML
    this.innerHTML = incomingPagination.innerHTML

    let headerHeight = document.querySelector('sc-header').clientHeight;
    let offsetTop = section.offsetTop - headerHeight;

    window.scrollTo({ top: offsetTop, behavior: 'smooth' });
  }
}

customElements.define('sc-default-pagination', ScDefaultPagination)

class ScInfiniteScroll extends ScShowMoreItems {
  constructor() {
    super()
    const pageStatusString = localStorage.getItem('delvify');
    const pageStatusObject = JSON.parse(pageStatusString);
      
    setTimeout(() => {
      if (pageStatusObject.current !== null && pageStatusObject.previous !== null) {
        if (typeof pageStatusObject.current === 'string' && typeof pageStatusObject.previous === 'string') {
          if (pageStatusObject.current.includes("/products/") && pageStatusObject.previous.includes("/collections/")) {
            if ('scrollRestoration' in history) {
              history.scrollRestoration = 'manual';
            }

            const url = document.querySelector('sc-infinite-scroll')?.dataset.page;
            const currentPage = document.querySelector('sc-infinite-scroll')?.dataset.currentpage;
            localStorage.setItem('oldPaginationUrl', url)
            document.querySelector('sc-infinite-scroll')?.setAttribute('data-page', url)
            document.querySelector('sc-infinite-scroll')?.setAttribute('data-currentpage', currentPage)
            document.querySelector('.js-previous-trigger')?.classList.remove('hidden')
          }
        }
      }

      const scrollTo = localStorage.getItem('productHandle')

      if (scrollTo !== null) {
        document.getElementById(`${scrollTo}`).scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }      
    }, 0); 
    this.setTargetData()

    let observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]['isIntersecting'] === true) {
          if (!this.classList.contains('disable-fetch')) {
            this.classList.add('disable-fetch')
            const oldUrl = localStorage.getItem('oldPaginationUrl')

            let shopifyID = this.dataset.id,
              url = `${this.dataset.page}&section_id=${shopifyID}`

            if (url !== oldUrl) {
              localStorage.setItem('oldPaginationUrl', url)
              this.getData(url)
            }
          }
        }
      },
      { threshold: 0 }
    )
    observer.observe(this)
  }

  getData(url) {
    fetch(url)
      .then((response) => response.text())
      .then((data) => {
        this.infiniteAppendElements(data)
      })
      .catch(() => {
        this.classList.remove('disable-fetch')
      })
  }

  addOrUpdateParameter(paramName, newValue) {
    var currentUrl = window.location.href;
    var urlParams = new URLSearchParams(window.location.search);
    urlParams.set(paramName, newValue);
    var newUrl = currentUrl.split('?')[0] + '?' + urlParams.toString();
    window.history.replaceState(null, null, newUrl);
  }

  infiniteAppendElements(data, e) {
    const parser = new DOMParser(),
      parsedHTML = parser.parseFromString(data, 'text/html')

    let incomingItems = parsedHTML.querySelector('.js-paginated-grid'),
      nextShowMore = parsedHTML.querySelector('.js-show-more-items'),
      itemGrid = this.closest('.js-grid-wrapper').querySelector('.js-paginated-grid')

    incomingItems.querySelector('.js-previous-item').classList.add('!hidden')
    itemGrid.innerHTML += incomingItems.innerHTML
 
    this.addOrUpdateParameter('page', nextShowMore.dataset.currentpage)
    document.querySelector('sc-infinite-scroll')?.setAttribute('data-page', nextShowMore.dataset.page)

    e.target.classList.remove('disable-fetch')
    e.target.querySelector('.collection-loader').classList.add('hidden')
  }

  setTargetData() {
    window.addEventListener('click', (e) => {
      if (e.target.classList.contains('js-product-card-link')) {
        e.preventDefault()
        const parent = e.target.closest('.js-pagination-card-counter')
        localStorage.setItem('productHandle', parent.dataset.handle)
        this.addOrUpdateParameter('page', parent.dataset.productcurrentpage);
        window.location.href = e.target.href;
      }
    })
  }
}

customElements.define('sc-infinite-scroll', ScInfiniteScroll)
